export const IFRAME_NAME = 'jumioIframe';
export const JUMIO_IFRAME = 'jumio-iframe';

export enum JUMIO_IFRAME_URLS {
    successUrl= 'jumio/jumio_success.html',
    errorUrl= 'jumio/jumio_error.html',
}
